module.exports = __webpack_public_path__ + "img/type3.c4e1657e.png";